var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-body" },
    [
      _c("div", { staticClass: "box-multi-channel-service" }, [
        _c("div", { staticClass: "m-n text-center" }, [
          _vm._v("マルチチャネルサービス設定　提出状況")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: ["box-status", _vm.multiChannelSenderItem.statusClass] },
          [_vm._v(_vm._s(_vm.multiChannelSenderItem.status))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: [
              "status-description description-" +
                _vm.multiChannelSenderItem.statusClass
            ]
          },
          [
            _vm.multiChannelSenderItem.key === "not_submitted"
              ? [
                  _c("div", { staticClass: "description-not-submitted" }, [
                    _vm._v("マルチチャネルサービス設定の証跡画像が未提出です。")
                  ])
                ]
              : _vm.multiChannelSenderItem.key == "reviewing"
              ? [
                  _c("div", [
                    _vm._v(
                      "ご提出いただいたマルチチャネルサービス設定の証跡画像を審査中です。"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm._v("審査中でも"),
                      _c(
                        "router-link",
                        {
                          staticClass: "text--underline",
                          attrs: {
                            to: { name: "ProductsNew", params: { tab: "list" } }
                          }
                        },
                        [_vm._v("商品管理画面")]
                      ),
                      _vm._v("より商品を出品していただくことが可能です。")
                    ],
                    1
                  )
                ]
              : _vm.multiChannelSenderItem.key == "reviewed_ok"
              ? [
                  _c("div", [
                    _vm._v(
                      "ご提出いただいたマルチチャネルサービス設定の証跡をご確認しました。"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "text--underline",
                          attrs: {
                            to: { name: "ProductsNew", params: { tab: "list" } }
                          }
                        },
                        [_vm._v("商品管理画面")]
                      ),
                      _vm._v("より商品を出品していただくことが可能です。")
                    ],
                    1
                  )
                ]
              : _vm.multiChannelSenderItem.key == "reviewed_not_good"
              ? [
                  _c("div", [
                    _vm._v(
                      "ご提出いただいたマルチチャネルサービス設定の証跡に不備があります。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v("マニュアルをご確認のうえ、再提出してください。")
                  ])
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.multiChannelSenderItem.isUploaded
          ? _c("div", { staticClass: "m-b-sm reupload-text" }, [
              _vm._v("再提出をされる方向け")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "box-status-content" }, [
          _c("div", { staticClass: "service-guide" }, [
            _vm._v(
              "\n        マニュアルを参考にマルチチャネルサービスの設定をして頂き、画面のキャプチャ画像をご提出ください。 "
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "url-setting-service-manual",
                attrs: {
                  href: _vm.documentMultiChannelSettingUrl,
                  target: "_blank"
                }
              },
              [_vm._v("マルチチャネルサービス設定マニュアル")]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "以下のボタンを選択した後、表示される画面よりファイルをご提出ください"
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-updload-evidence",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.openUploaderModal()
                }
              }
            },
            [_vm._v("ファイルを提出する")]
          )
        ]),
        _vm._v(" "),
        _vm.multiChannelSenderItem.isUploaded && _vm.evidenceImage
          ? _c("div", { staticClass: "box-uploaded-evidence-image" }, [
              _c("span", [_vm._v("提出済画像（クリックで拡大）")]),
              _vm._v(" "),
              _c("div", { staticClass: "box-evidence-image m-t-sm pd-l-30" }, [
                _c("img", {
                  staticClass: "evidence-image img-responsive",
                  attrs: { src: _vm.evidenceImage },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.showZoomInModal()
                    }
                  }
                })
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("upload-evidence-image-modal", {
        on: {
          close: _vm.closeUploaderModal,
          handleSuccess: _vm.uploadedEvidenceImageSuccess
        }
      }),
      _vm._v(" "),
      _vm.showZoomInEvidenceImageModal
        ? _c("zoom-in-evidence-image-modal", {
            attrs: { imagePath: _vm.evidenceImage },
            on: { close: _vm.closeZoomInModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60e79f9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60e79f9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAmazon/MultiChannelService.vue
// module id = null
// module chunks = 